import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';
import BonusHomeBannerItem from './components/BonusHomeBannerItem';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import { useTriggerBonusHomeBannerGAEvents } from './hooks/useTriggerBonusHomeBannerGAEvents';
import {
  TOP_VHP_BANNER, BOTTOM_VHP_BANNER, TOP_MHP_BANNER, BOTTOM_MHP_BANNER,
} from './utils/instanceTypes';
import List from 'core/modules/Partials/List/List';

import config from './configs';
import './BonusHomeBanner.scss';

const classNames = {
  [TOP_VHP_BANNER]: 'mn_vhpBonusTopBanner',
  [BOTTOM_VHP_BANNER]: 'mn_vhpBonusBottomBanner',
  [TOP_MHP_BANNER]: 'mn_mhpBonusTopBanner',
  [BOTTOM_MHP_BANNER]: 'mn_mhpBonusBottomBanner',
};

function BonusHomeBanner({ instanceType }) {
  const { publicAutomaticOffersToShow, bonusRollingAndPublicAutomaticOffersToShow } = useGetBonusOffers();
  const { carousel, shouldShowRollingBonuses } = config;
  const [activeBonusIndex, setActiveBonusIndex] = useState(0);

  const getOffersToShow = () => {
    if (instanceType === TOP_MHP_BANNER && shouldShowRollingBonuses) {
      return bonusRollingAndPublicAutomaticOffersToShow;
    }
    return publicAutomaticOffersToShow;
  };

  const placementsToShow = getOffersToShow();

  useTriggerBonusHomeBannerGAEvents(placementsToShow, activeBonusIndex, instanceType);

  if (isEmpty(placementsToShow)) {
    return null;
  }

  const afterChangeHandler = (carouselApi) => {
    const currentSlideIndex = carouselApi?.selectedScrollSnap() || 0;
    setActiveBonusIndex(currentSlideIndex);
  };
  const hasMultipleBonuses = placementsToShow.length > 1;

  return (
    <div className={`mn_bonusHomeBannerWrap ${classNames[instanceType]}`}>
      <ContentWrap>
        <div className={`mn_bonusHomeBanner ${hasMultipleBonuses ? 'mn_multiple' : ''}`}>
          <List options={carousel} shouldUseCarousel={hasMultipleBonuses} onSettle={afterChangeHandler}>
            {placementsToShow.map(item => (
              <BonusHomeBannerItem
                key={item.id}
                item={item}
                instanceType={instanceType}
              />
            ))}
          </List>
        </div>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><BonusHomeBanner {...props} /></ComponentErrorBoundary>;
